import { validatePassword, } from "@pangeacyber/react-mui-shared";
import * as yup from "yup";
import PasswordWithGenerateField from "./PasswordWithGenerateField";
import PasswordWithMatchField from "./PasswordWithMatchField";
export var getCreateProtectedFileFields = function (_a) {
    var policy = _a.policy;
    return ({
        password: {
            label: "Type password",
            component: PasswordWithGenerateField,
            schema: yup
                .string()
                .test("password-requirements", "New password does not meet requirements.", function (value) {
                if (value) {
                    var errors = validatePassword(value, policy);
                    return Object.keys(errors).length === 0;
                }
                return true;
            })
                .required("Password is required."),
        },
        retyped_password: {
            label: "Re-type password",
            component: PasswordWithMatchField,
            schema: yup
                .string()
                .required("New password must be confirmed.")
                .oneOf([yup.ref("password"), ""], "Passwords must match."),
        },
    });
};
